<template>
  <div v-if="datalensSrc" class="dashboard-container">
    <iframe :src="datalensSrc"/>

    <div v-if="showSubscribeOverlay" class="subscribe-overlay">
      <div class="subscribe-overlay-gradient"></div>
      <div class="subscribe-component-container">
        <button class="close-button" @click="closeOverlay">&times;</button>
        <div class="subscribe-component-container-lock">
          <img :src="lockIcon" alt="Lock Icon"/>
        </div>
        <div class="subscribe-component-title">
          В бесплатном тарифе доступны лишь ограниченные демо-данные. 
          Чтобы получить доступ к аналитике по любым нужным вам регионам, 
          видам транспортных средств и к другим возможностям, оформите подписку.
        </div>
        <button class="subscribe-component-view-tariffs-button" @click="redirectToTiers">
          Посмотреть тарифы
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LockIcon from '@/assets/images/lock-for-subscribe.svg';
import {generateDatalensToken} from "@/utils/requests";

export default {
  name: "DashBoard",
  props: {
    filters: Object
  },
  data() {
    return {
      datalensUrl: null,
      intervalId: null,
      lockIcon: LockIcon,
      subscribeOverlay: true
    }
  },
  computed: {
    ...mapGetters('main', ['userInfo']),
    canViewDatasets() {
      return this.userInfo.can_view_datasets || false;
    },
    showSubscribeOverlay() {
      return !this.canViewDatasets && this.subscribeOverlay;
    },
    datalensSrc() {
      return this.datalensUrl;
    }
  },
  watch: {
    filters: {
      deep: true
    }
  },
  methods: {
    closeOverlay() {
      this.subscribeOverlay = false;
    },
    redirectToTiers() {
      this.$router.push('/profile');
    },
    async fetchUpdatedToken() {
      try {
        const response = await generateDatalensToken(localStorage.getItem('token'));

        const data = await response.json();
        if (!response.ok || !data.data.token) {
          throw new Error(data);
        }

        this.datalensUrl = `${process.env.VUE_APP_DATALENS_ANALYTICS_URL}?tab=widget&mode=embedded&_theme=light&_lang=ru&access_token=${data.data.token}`;
      } catch (err) {
        console.error('Error while fetching JWT:', err)
      }
    }
  },
  mounted() {
    this.fetchUpdatedToken();
    this.intervalId = setInterval(() => {
      this.fetchUpdatedToken();
    }, 30 * 60 * 1000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  }
}
</script>

<style scoped>
.dashboard-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 96px);
}

iframe {
  border: none;
  display: flex;
  width: 100%;
  height: 100%;
}

.subscribe-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 33%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  pointer-events: none;
}

.subscribe-overlay-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.1) 0%,
      rgba(255, 255, 255, 0.8) 40%,
      rgba(255, 255, 255, 0.9) 70%,
      rgba(255, 255, 255, 1) 100%
  );
  pointer-events: none;
}

.subscribe-component-container {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.95);
  pointer-events: all;
  z-index: 1;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  color: #23282c;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.close-button:hover {
  background-color: rgba(35, 40, 44, 0.1);
}

.subscribe-component-container-lock {
  margin-bottom: 20px;
}

.subscribe-component-title {
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  width: 450px;
  text-align: center;
  color: #23282C;
  margin-bottom: 20px;
}

.subscribe-component-view-tariffs-button {
  padding: 12px 20px;
  background-color: #c23132;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  border-radius: 4px;
  width: 256px;
  height: 56px;
  margin-bottom: 20px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s;
}
</style>
